module.exports = __webpack_public_path__ + "static/media/cy.f7a0d2a6.svg";